import React, { CSSProperties } from "react";
import Ruler from "@scena/react-ruler";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
export interface RulerProps {
  type?: "horizontal" | "vertical";
  style?: CSSProperties;
}
export const RulerComponent = ({ type, style }: RulerProps) => {
  const rulerRef = React.useRef<Ruler | null>(null);
  const pxInMM = useSelector(
    (state: RootState) => state.labelEdit.present.labelParams.pxInMM
  );
  React.useEffect(() => {
    if (rulerRef.current) {
      rulerRef.current.resize();
    }

    const handleResize = () => {
      if (rulerRef.current) {
        rulerRef.current.resize();
      }
    };

    // let scrollX = 0;
    // let scrollY = 0;
    // window.addEventListener("wheel", (e) => {
    //   scrollX += e.deltaX;
    //   scrollY += e.deltaY;

    //   // rulerRef.current.scrollGuides(scrollY);
    //   if (rulerRef.current && e.deltaX !== 0) {
    //     rulerRef.current.scroll(scrollX);
    //   } else if (rulerRef.current && e.deltaY !== 0) {
    //     rulerRef.current.scroll(scrollY);
    //   }
    // });
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Ruler
      type={type}
      zoom={pxInMM}
      unit={10} //1cm
      backgroundColor="white"
      textColor="black"
      lineColor="black"
      style={style}
      ref={rulerRef}
    />
  );
};
